import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import ReactQuill from "react-quill";
import axios from "axios";

import DropZone from "../DropZone";
import GlobalContext from "../../../Hooks/globalContext";
import "../../../Styles/writeForm.scss";
import useState from "../../../Hooks/useState";
import DefaultButton from "../../Common/DefaultButton";
import useInput from "../../../Hooks/useInput";
import Input from "../../Common/Input";
import { HOST, NUMBER_REGEX } from "../../../Utils/constants";
import Loader from "../../Common/Loader";

const Top = styled.div`
  height: calc(100% - 60px);
  width: 100%;
`;

const Bottom = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
`;

const BottomItem = styled.div``;

const Page = ({ adminPage, focus }) => {
  const { httpHeader, modal } = useContext(GlobalContext);
  const titleInput = useInput({ defaultValue: focus.state ? focus.state.title : "", maxLength: 100 });
  const priceInput = useInput({ defaultValue: focus.state ? focus.state.price_krw : "", regex: NUMBER_REGEX });
  const amountInput = useInput({ defaultValue: focus.state ? focus.state.amount : "", regex: NUMBER_REGEX });

  const detail = useState(null);
  const images = useState(null);
  const editorHtml = useState("");

  const getDetail = async () => {
    const { data } = await axios.post(`${HOST}/admin/product/detail`, { id: focus.state.id }, httpHeader());
    detail.setState(data);
    editorHtml.setState(data.content);
  };

  const preload = () => {
    if (!focus.state) {
      init();
    } else {
      getDetail();
    }
  };
  const writeOnChange = (html) => {
    editorHtml.setState(html);
  };
  const writeOnClick = async () => {
    if (titleInput.value.length < 2) {
      modal.setState("제목이 짧습니다.");
      return;
    }
    if (priceInput.value.length < 1) {
      modal.setState("잘못된 금액입니다.");
      return;
    }
    if (amountInput.value.length < 1) {
      modal.setState("잘못된 수량입니다.");
      return;
    }
    if (!focus.state && !images.state) {
      modal.setState("미리보기 이미지를 등록해주세요.");
    }

    // const requestBody = {
    //   title: titleInput.value,
    //   content: editorHtml.state,
    //   price: priceInput.value,
    //   amount: amountInput.value,
    //   action: type,
    //   image: images.state,
    //   id: type === "create" ? null : focus.state.id,
    // };

    const requestBody = new FormData();
    requestBody.append("title", titleInput.value);
    requestBody.append("content", editorHtml.state);
    requestBody.append("price", priceInput.value);
    requestBody.append("amount", amountInput.value);
    requestBody.append("action", focus.state ? "update" : "create");
    requestBody.append("image", images.state);
    requestBody.append("id", focus.state ? focus.state.id : null);
    const { data } = await axios.post(`${HOST}/admin/product`, requestBody, httpHeader());

    if (data.status) {
      modal.setState("성공적으로 처리되었습니다.");
      init();
      adminPage.setState("mallList");
    } else {
      modal.setState(`오류 : ${data.code}`);
    }
  };

  const init = () => {
    titleInput.setValue("");
    priceInput.setValue("");
    amountInput.setValue("");
    editorHtml.setState("");
    images.setState(null);
  };

  useEffect(preload, [focus.state]);
  return (
    <>
      <Top>
        {focus.state ? (
          detail.state ? (
            <>
              <Input {...titleInput} placeholder="* 제목" style={customInput} />
              <Input {...priceInput} placeholder="* 가격" style={customInput} />
              <Input {...amountInput} placeholder="* 수량" style={customInput} />
              <DropZone focus={detail} images={images} />
              <ReactQuill
                theme="snow"
                onChange={writeOnChange}
                value={editorHtml.state}
                modules={EDITOR_MODULES}
                formats={EDITOR_FORMATS}
                bounds={".app"}
                placeholder={""}
              />
            </>
          ) : (
            <Loader />
          )
        ) : (
          <>
            <Input {...titleInput} placeholder="* 제목" style={customInput} />
            <Input {...priceInput} placeholder="* 가격" style={customInput} />
            <Input {...amountInput} placeholder="* 수량" style={customInput} />
            <DropZone focus={detail} images={images} />
            <ReactQuill
              theme="snow"
              onChange={writeOnChange}
              value={editorHtml.state}
              modules={EDITOR_MODULES}
              formats={EDITOR_FORMATS}
              bounds={".app"}
              placeholder={""}
            />
          </>
        )}
      </Top>
      <Bottom>
        <BottomItem></BottomItem>
        <BottomItem></BottomItem>
        <BottomItem>
          <DefaultButton text="작성" onClick={writeOnClick} />
        </BottomItem>
      </Bottom>
    </>
  );
};

export default Page;

const EDITOR_FORMATS = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];
const EDITOR_MODULES = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};

const customInput = {
  width: "100%",
  border: "1px solid #ccc",
  padding: "5px 10px",
  marginBottom: "5px",
  borderRadius: "4px",
  outline: "none",
  backgroundColor: "white",
  color: "black",
};
